/**
 * UserStatusBar Component
 * 
 * Kullanıcı durumu ve analiz hakkı bilgisini gösteren bar.
 * Dunning ve past_due durumlarında kritik uyarı gösterir.
 */

import { AlertTriangle, CreditCard, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { getPaymentUpdatePath } from "@/utils/localePaths";

const UserStatusBar = ({ user }) => {
  const { t, locale } = useTranslation();
  // Güvenlik: user yoksa render etme
  if (!user) return null;

  // Plan isimlerini Türkçeleştir
  const getPlanDisplayName = (planType) => {
    const planNames = {
      'free': t('plans.free'),
      'package_10': t('plans.package_10'),
      'package_50': t('plans.package_50'),
      'package_100': t('plans.package_100'),
      'pro_monthly': t('plans.pro_monthly'),
      'business_monthly': t('plans.business_monthly'),
      'persona_staff': 'Persona Staff'
    };
    return planNames[planType] || planType || t('plans.free');
  };

  // ONCELIK 0: Hesap Dondurma (past_due) - TURUNCU Banner
  if (user.subscription_status === 'past_due') {
    return (
      <div className="mb-4 p-4 bg-orange-900/40 border-2 border-orange-500 rounded-lg" data-testid="user-status-frozen">
        <div className="flex items-center gap-3">
          <Clock className="w-6 h-6 text-orange-400 shrink-0 animate-pulse" />
          <div className="flex-1">
            <p className="text-orange-200 font-semibold">
              {t('userstatus.frozen_heading')}
            </p>
            <p className="text-orange-300 text-sm mt-1">
              {t('userstatus.frozen_body')}
            </p>
          </div>
          <Link
            to={getPaymentUpdatePath(locale)}
            className="shrink-0 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
            data-testid="pay-now-btn"
          >
            {t('userstatus.pay_now')}
          </Link>
        </div>
      </div>
    );
  }

  // ÖNCELİK 2: Dunning durumu - Kritik uyarı (KIRMIZI)
  if (user.dunning_status === 'failed') {
    return (
      <div className="mb-4 p-4 bg-red-900/40 border-2 border-red-500 rounded-lg" data-testid="user-status-dunning">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-6 h-6 text-red-400 shrink-0" />
          <div className="flex-1">
            <p className="text-red-200 font-semibold">
              {t('userstatus.dunning_heading')}
            </p>
            <p className="text-red-300 text-sm mt-1">
              {t('userstatus.dunning_body')}
              {user.dunning_days_left && (
                <span className="font-bold"> {t('userstatus.dunning_warning', { days: user.dunning_days_left })}</span>
              )}
            </p>
          </div>
          <Link
            to={getPaymentUpdatePath(locale)}
            className="shrink-0 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
          >
            {t('userstatus.update_card')}
          </Link>
        </div>
      </div>
    );
  }

  // ÖNCELİK 2: Normal durum - UserStatusBar GİZLİ (kullanıcı isteği üzerine kaldırıldı)
  // Paket ve kredi bilgisi artık gösterilmiyor
  return null;
};

export default UserStatusBar;
